// src/components/importData/utils/constants.js

export const SOURCE_OPTIONS = [
  {
    id: 'integral',
    label: 'İntegral',
    acceptedFormats: '.pdf',
    referenceFile: 'PDF'
  },
  {
    id: 'akbank',
    label: 'Akbank',
    acceptedFormats: '.csv',
    referenceFile: 'CSV'
  },
  {
    id: 'eyatirimci',
    label: 'E-Yatırımcı',
    acceptedFormats: '.xls,.xlsx',
    referenceFile: 'Excel'
  },
  {
    id: 'ibkr',
    label: 'Interactive Brokers',
    acceptedFormats: '.xml,.qfx',
    referenceFile: 'XML (Flex Query) veya QFX'
  },
  {
    id: 'ibkr_web',
    label: 'IBKR - Web API',
    acceptedFormats: null,
    referenceFile: 'Online Bağlantı'
  },
  {
    id: 'smart_portfolio_json',
    label: 'Smart Portfolio (JSON)',
    acceptedFormats: '.json',
    referenceFile: 'JSON'
  }
];

// Hisse senedi alanları için sabitler
export const STOCK_FIELDS = {
  SYMBOL: 'symbol',
  SHARES: 'shares',
  PRICE: 'price',
  TOTAL: 'total',
  COST: 'cost',
  PROFIT_LOSS: 'profitLoss'
};

// Dosya türleri için MIME tipleri
export const MIME_TYPES = {
  PDF: 'application/pdf',
  CSV: 'text/csv',
  EXCEL: [
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ]
};

// Hata mesajları
export const ERROR_MESSAGES = {
  NO_SOURCE: 'Lütfen bir veri kaynağı seçin',
  INVALID_FORMAT: (format) => `Lütfen ${format} formatında bir dosya yükleyin`,
  NO_DATA: 'Dosyada işlenebilir veri bulunamadı',
  PARSE_ERROR: 'Dosya işlenirken bir hata oluştu',
  FILE_TOO_LARGE: 'Dosya boyutu çok büyük',
  INVALID_FILE: 'Geçersiz dosya formatı'
};

// Maksimum dosya boyutu (10MB)
export const MAX_FILE_SIZE = 10 * 1024 * 1024;